import { Avatar, Text } from "react-native-paper";
import { useAppTheme } from "../useAppTheme";
import Box from "./Box";
import RenderMarkdown from "./MarkdownRenderer";

interface Message {
	name: string;
	avatarUrl: string;
	content: string;
}

interface ConversationRendererProps {
	messages: Message[];
}

export const ConversationRenderer = ({
	messages,
}: ConversationRendererProps) => {
	const theme = useAppTheme();
	return (
		<Box flexGrow={1} gap={16} userSelect="none">
			{messages.map((message, index) => (
				<Box key={`${index}-${message.name}`} flexDirection="row" gap={8}>
					<Avatar.Image size={32} source={{ uri: message.avatarUrl }} />

					<Box
						flex={1}
						borderRadius={theme.roundness}
						padding={12}
						gap={4}
						backgroundColor={theme.colors.primaryContainer}
					>
						<Text variant="titleSmall">{message.name}</Text>
						<RenderMarkdown
							text={message.content}
							fontSize={14}
							customStyles={{
								text: {
									lineHeight: 16 * 1.4,
									color: theme.colors.onSurfaceVariant,
								},
								paragraph: {
									lineHeight: 22,
									marginBottom: 8,
								},
							}}
						/>
					</Box>
				</Box>
			))}
		</Box>
	);
};

export default ConversationRenderer;
